module.exports = __webpack_public_path__ + "static/media/Fomomedia.63614a43.jpg";